import { Component, OnInit, Output} from '@angular/core';
import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';
var $;
@Component({
  selector: 'app-carrucel',
  templateUrl: './carrosusel-sectores-productivos.component.html',
  styleUrls: ['./carrosusel-sectores-productivos.component.css']
})
export class CarrucelSectoresProductivos implements OnInit {
  slides = [
  {'image': './assets/images/01r.jpg'},
  {'image': './assets/images/02.jpg'},
  {'image': './assets/images/03.jpg'},
  {'image': './assets/images/04.jpg'},
  {'image': './assets/images/05.jpg'},
  {'image': './assets/images/07.jpg'},
  {'image': './assets/images/08.jpg'},
  {'image': './assets/images/09.jpg'},
  {'image': './assets/images/10.jpg'},
  {'image': './assets/images/11.jpg'},
  {'image': './assets/images/12.jpg'},
  {'image': './assets/images/13.jpg'},
  {'image': './assets/images/14.jpg'},
  {'image': './assets/images/15.jpg'},
  {'image': './assets/images/16.jpg'},
  {'image': './assets/images/17.jpg'},
  {'image': './assets/images/18.jpg'},
  {'image': './assets/images/19.jpg'},
  {'image': './assets/images/20.jpg'},
  {'image': './assets/images/21.jpg'},
  {'image': './assets/images/22.jpg'},
  {'image': './assets/images/23.jpg'},
  {'image': './assets/images/24.jpg'},
  {'image': './assets/images/25.jpg'}
];



  constructor() {
     
   }

  ngOnInit() {
   
  }

 
}
